import { api, getAuthHeader, getDocAuthHeader } from './help';

export const getQBOAuth = async () => {
  const response = await api.get('/invoice/Oauth', getAuthHeader());
  return response.data;
};

export const getInvoiceList = async (payload) => {
  const response = await api.post('/invoice/list', payload, getAuthHeader());
  return response.data;
};

export const getInvoiceLineList = async (payload) => {
  const response = await api.post('/invoice/line-list', payload, getAuthHeader());
  return response.data;
};

export const getInvoiceDisputeHistoryList = async (payload) => {
  const response = await api.post('/invoice/dispute-history-list', payload, getAuthHeader());
  return response.data;
};

export const getInvoiceDetail = async (invoiceId) => {
  const response = await api.get(`/invoice/${invoiceId}/detail`, getAuthHeader());
  return response.data;
};

export const getInvoicePDF = async (invoiceId) => {
  const id = invoiceId?.invoiceId ?? invoiceId;
  const response = await api.get(`/invoice/pdf?id=${encodeURIComponent(id)}`, getDocAuthHeader());
  return response.data;
};

export const sendDispute = async (data) => {
  const response = await api.post('/invoice/dispute', data, getAuthHeader());
  return response.data;
};

export const fetchInvoicePolicy = async (data) => {
  const riderId = encodeURIComponent(data ?? '');
  const response = await api.get(`/invoice/policy?riderId=${riderId}`, getAuthHeader());
  return response.data;
};

export const searchInvoiceNumber = async (data) => {
  const invoiceNum = encodeURIComponent(data ?? '');
  const response = await api.get(`/invoice/search?invoiceNum=${invoiceNum}`, getAuthHeader());
  return response.data;
};
